<script setup lang="ts">
import TemplateDownloadGraphics from 'assets/graphics/template-list-download.svg'

const { downloadImportTemplate } = useMembers()

const handleDownloadTemplate = () => handleAsync(downloadImportTemplate, 'Fehler beim Herunterladen der Mitgliederliste Vorlage')
</script>

<template>
	<ion-card>
		<div
			class="template-download-graphic"
			style="cursor: pointer"
			@click="handleDownloadTemplate"
		>
			<ion-img
				:src="TemplateDownloadGraphics"
				alt="Mitgliederliste Vorlage"
				style="cursor: pointer; margin: auto"
			/>
		</div>
		<ion-card-header>
			<ion-card-title>Mitgliederliste (Vorlage)</ion-card-title>
		</ion-card-header>
		<ion-card-content>
			<ion-text>Sie wollen mehrere Mitglieder gleichzeitig erfassen?<br>Kein Problem:</ion-text>
			<ol>
				<li>Liste zum Erfassen der Vereinsmitglieder herunterladen</li>
				<li>Liste ausfüllen</li>
				<li>Liste bei Verein-CheckIn hochladen</li>
			</ol>
		</ion-card-content>
	</ion-card>
</template>

<style lang="scss" scoped>
ion-card {
	box-shadow: none;
	border: 1px solid var(--ion-color-secondary);
	border-radius: 8px;
	ion-card-header {
		ion-card-title {
			font-size: 16px;
			font-weight: 700;
			color: var(--ion-text-color)
		}
	}
	ion-card-content {
		font-size: 12px;
		font-weight: 400;
		color: var(--ion-text-color);
		ol {
			padding-left: 15px;
		}
	}

	.template-download-graphic {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 220px;
		background: var(--ion-color-dashboard-yellow);
	}
}
</style>
